class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId
    );
  }

  // onCartUpdate() {
  //   fetch(`${routes.cart_url}?section_id=main-cart-items`)
  //     .then((response) => response.text())
  //     .then((responseText) => {
  //       const html = new DOMParser().parseFromString(responseText, 'text/html');
  //       const sourceQty = html.querySelector('cart-items');
  //       this.innerHTML = sourceQty.innerHTML;
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  // }
  onCartUpdate() {
    // Get the sections to render (cart items and footer)
    const sections = this.getSectionsToRender();

    // Create an array to hold the fetch promises for both sections
    const fetchPromises = sections.map(({ id, section }) => {
      return fetch(`${routes.cart_url}?section_id=${section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newSectionContent = html.querySelector(`#${id} .js-contents`);

          // Return the updated content for this section
          return { id, newSectionContent };
        });
    });

    // Wait for all fetch promises to resolve
    Promise.all(fetchPromises)
      .then((results) => {
        // Iterate over the results and update the content of each section
        results.forEach(({ id, newSectionContent }) => {
          const targetSection = document.querySelector(`#${id} .js-contents`);

          // If we found the target section and the new content, update it
          if (newSectionContent && targetSection) {
            targetSection.innerHTML = newSectionContent.innerHTML;
          }
        });
      })
      .catch((error) => {
        console.error('Error updating cart sections:', error);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body,
      });

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      // Refresh the cart content for cart page (not drawer)
      if (window.location.pathname.includes('/cart')) {
        await this.onCartUpdate();
      }

      // Get updated cart state
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      const cartState = await cartResponse.json();

      // Get updated drawer HTML
      const drawerResponse = await fetch(`?section_id=cart-drawer`);
      const drawerHtml = await drawerResponse.text();

      // Update the cart drawer, if it exists
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const newDrawerContent = doc.querySelector('cart-drawer-items');
        const newEmptyState = doc.querySelector('.drawer__inner-empty');
        const newFooterContent = doc.querySelector('.drawer__footer');

        const existingDrawerItems = cartDrawer.querySelector('cart-drawer-items');
        const existingEmptyState = cartDrawer.querySelector('.drawer__inner-empty');
        const existingFooter = cartDrawer.querySelector('.drawer__footer');

        if (cartState.item_count === 0 && newEmptyState) {
          // Remove items if they exist
          if (existingDrawerItems) existingDrawerItems.remove();
          if (existingFooter) existingFooter.remove();

          // Replace or insert empty state
          if (existingEmptyState) {
            existingEmptyState.replaceWith(newEmptyState);
          } else {
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) {
              drawerInner.innerHTML = '';
              drawerInner.appendChild(newEmptyState);
            }
          }
        } else if (newDrawerContent && newFooterContent) {
          if (existingDrawerItems) existingDrawerItems.replaceWith(newDrawerContent);
          if (existingFooter) existingFooter.replaceWith(newFooterContent);

          // Remove empty state if it exists
          if (existingEmptyState) existingEmptyState.remove();
        }

        // Toggle empty class
        cartDrawer.classList.toggle('is-empty', cartState.item_count === 0);

        // Update cart counts
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          const countBubble = document.createElement('div');
          countBubble.classList.add('cart-count-bubble');
          countBubble.innerHTML = `<span aria-hidden="true">${cartState.item_count}</span><span class="visually-hidden">${cartState.item_count} items</span>`;
          bubble.replaceWith(countBubble);
        });

        // Handle focus
        if (cartState.item_count === 0 && cartDrawer.querySelector('.drawer__inner-empty')) {
          trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
        } else if (document.querySelector('.cart-item')) {
          trapFocus(cartDrawer, document.querySelector('.cart-item__name'));
        }
      }

      // Notify subscribers (both drawer + cart page)
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });

    } catch (error) {
      console.error('Error updating cart:', error);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      if (quantityElement) {
        quantityElement.value = quantityElement.getAttribute('value');
      }
    } finally {
      this.disableLoading(line);
    }
  }
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }



  enableLoading(line) {
    const mainCartItems = document.querySelector('#main-cart-items') || document.getElementById('CartDrawer-CartItems');
    const cartWarnings = document.querySelector('#cart-warnings');
    const mainCartFooter = document.querySelector('#main-cart-footer');
    const allCartItems = document.querySelectorAll('.cart__contents .cart-item');
    const cartList = document.querySelector('.cart__contents .cart-items');
    const cartWarn = document.querySelector('.cart__warnings');
    const mainCartFoot = document.querySelector('.cart__footer');

    const cartItemOverlays = [
      ...this.querySelectorAll(`#CartItem-${line} .loading-overlay`),
      ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`)
    ];

    // Disable interaction
    mainCartItems?.classList.add('cart__items--disabled');
    cartItemOverlays.forEach(overlay => overlay.classList.remove('hidden'));
    document.activeElement?.blur();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);

    // Handle empty cart only on cart page
    const isCartPage = document.getElementById('main-cart-items') !== null;

    if (isCartPage && allCartItems.length == 1) {
      mainCartFooter.classList.add('is-empty');
      cartWarn.classList.add('open');
      cartList?.classList.add('is-empty');
      mainCartItems.classList.add('is-empty');
    } 
    
    if (isCartPage && allCartItems.length == 2) {
      mainCartFooter.classList.add('is-empty');
      cartWarn.classList.add('open');
      cartList?.classList.add('is-empty');
      mainCartItems.classList.add('is-empty');                                                                                                                                                  
    }
  }


  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    const allCartItems = document.querySelectorAll('.cart__contents .cart-item');

    const root = document.contains(this) ? this : document;
    const cartItemOverlays = [
      ...root.querySelectorAll(`#CartItem-${line} .loading-overlay`),
      ...root.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`)
    ];

    // Re-enable interaction
    mainCartItems?.classList.remove('cart__items--disabled');
    cartItemOverlays.forEach(overlay => overlay.classList.add('hidden'));
  }


}

customElements.define('cart-items', CartItems);

